/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExpireInputs */

const cs_enum_expire = /** @type {(inputs: Enum_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vypršení`)
};

const en_enum_expire = /** @type {(inputs: Enum_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expire`)
};

/**
* | output |
* | --- |
* | "Expire" |
*
* @param {Enum_ExpireInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_expire = /** @type {((inputs?: Enum_ExpireInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExpireInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_expire(inputs)
	return cs_enum_expire(inputs)
});